export default "__VITE_ASSET__CiC$cXvf__"